import { render, staticRenderFns } from "./KindergartenIcon.vue?vue&type=template&id=2f9242e8&scoped=true"
import script from "./KindergartenIcon.vue?vue&type=script&lang=js"
export * from "./KindergartenIcon.vue?vue&type=script&lang=js"
import style0 from "./KindergartenIcon.vue?vue&type=style&index=0&id=2f9242e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9242e8",
  null
  
)

export default component.exports